import CarContainer1, { NormalCard, CarListingCard, VehicleListingCard } from '@common/pages/Dashboard/components/CarContainer1';
import CarsList from '@common/pages/Dashboard/components/CarsList';
import { auctionTypes } from '@common/utils/constants/auction';
import { Cancel } from '@mui/icons-material';
import { Box, Chip, Grid, Pagination, Paper, Skeleton, Typography, useMediaQuery, useTheme } from '@mui/material';
import debounce from 'lodash.debounce';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { baseImageUrl } from '../../../../api';
import { reducerPaths } from '../../../../app/reducerPaths';
import theme from '../../../../theme';
import {
  useLazyGetOthersCarsInNegotiationBuyNowQuery,
  useLazyGetOthersCarsInNegotiationQuery,
  useLazyGetOwnCarsInNegotiationBuyNowQuery,
  useLazyGetOwnCarsInNegotiationQuery,
} from '../../../../toolkit/carsInNegotiation/carsInNegotiationApi';
import { routes } from '../../../../utils/constants/routes';
import MyCarsOrOtherCarsButton, { defaultValue } from '../common/MyCarsOrOtherCarsButton';
import * as styles from '../FilteringPaginationSx'; // Import the styles
import { useListenForNewCarsInNego } from './customHooks/useListenForNewCarsInNego';

const CarsInNegotationList = ({ selectedCar, setSelectedCar, paginationHandler, onCarClick, onMyCarsOrOtherCars }) => {
  // static data start....
  const paginationDataInit = React.useMemo(() => {
    return {
      current_page: 1,
      last_page: 1,
      data: [],
      isFetching: true,
    };
  }, []);
  // static data end....

  // useLocation...
  const location = useLocation();
  // useLocation...

  const subRoute = location?.pathname?.split?.(`${routes?.dashboardNavigation}/`)?.[1]?.split?.(`/`)?.[0];

  const liveAuctionOrBuyNow = location?.pathname?.includes?.(`${routes.carsInNegotiationBuyNow}`)
    ? auctionTypes.buyNow
    : auctionTypes.liveAuction;

  // useDispatch...
  const dispatch = useDispatch();
  const { t } = useTranslation('carsInNegotiation');
  const muiTheme = useTheme();

  // Responsive breakpoints
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(muiTheme.breakpoints.between('sm', 'md'));
  // useDispatch...

  // useSelector start...
  const carsInNegotiation = useSelector((store) => store[reducerPaths.carsInNegotiation]);
  // useSelector end..

  const onNewCarInNegoHandler = async (vehicle) => {
    await fetchPaginationDataHandler({
      params
    });
  };

  // custom hooks start...
  const [getOwnCarsInNegotiationApiHandler, getOwnCarsInNegotiationApiData] = useLazyGetOwnCarsInNegotiationQuery();
  const [getOwnCarsInNegotiationBuyNowApiHandler, getOwnCarsInNegotiationBuyNowApiData] =
    useLazyGetOwnCarsInNegotiationBuyNowQuery();
  const [getOthersCarsInNegotiationApiHandler, getOthersCarsInNegotiationApiData] =
    useLazyGetOthersCarsInNegotiationQuery();
  const [getOthersCarsInNegotiationBuyNowApiHandler, getOthersCarsInNegotiationBuyNowApiData] =
    useLazyGetOthersCarsInNegotiationBuyNowQuery();
  useListenForNewCarsInNego({
    onNewCarInNegoHandler: onNewCarInNegoHandler
  });
  // custom hooks end...

  const [allMakes, setAllMakes] = React.useState([]);
  const [allModels, setAllModels] = React.useState([]);
  const [allYears, setAllYears] = React.useState([]);

  const [selectedMakes, setSelectedMakes] = React.useState(['']);
  const [selectedModels, setSelectedModels] = React.useState(['']);
  const [selectedYearFrom, setSelectedYearFrom] = React.useState('');
  const [selectedYearTo, setSelectedYearTo] = React.useState('');
  const [odometerFrom, setOdometerFrom] = React.useState('');
  const [odometerTo, setOdometerTo] = React.useState('');
  const [selectedBrands, setSelectedBrands] = React.useState([]);
  const [value, setValue] = React.useState(defaultValue);
  const [paginationData, setPaginationData] = React.useState(paginationDataInit);

  const params = React.useMemo(() => {
    return {
      Year: selectedYearFrom,
      Make: selectedMakes?.map((item) => item?.label)?.join(','), // Pass make names
      Model: selectedModels?.map((item) => item?.label)?.join?.(','), // Pass model names
      from_year: selectedYearFrom,
      to_year: selectedYearTo,
      from_Mileage: odometerFrom,
      to_Mileage: odometerTo,
      page: paginationData?.current_page,
    };
  }, [
    selectedYearFrom,
    selectedMakes,
    selectedModels,
    selectedYearTo,
    odometerFrom,
    odometerTo,
    paginationData?.current_page,
  ]);

  const handlePageChange = (e, page) => {
    console.log(page, 'handlePageChange');
    setPaginationData((paginationData) => {
      return {
        ...paginationData,
        current_page: page,
      };
    });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const fetchPaginationDataHandler = async ({ params }) => {
    if (!paginationHandler) {
      return;
    }

    let res;

    setPaginationData((paginationData) => {
      return {
        ...paginationData,
        isFetching: true,
      };
    });

    console.log(`fetchPaginationDataHandler`);

    if (subRoute === routes?.carsInNegotiation?.split?.('/')?.[1]) {
      if (value === 1) {
        res = await getOthersCarsInNegotiationApiHandler({
          params,
        });
      } else {
        res = await getOwnCarsInNegotiationApiHandler({
          params,
        });
      }
    } else {
      if (value === 1) {
        res = await getOthersCarsInNegotiationBuyNowApiHandler({
          params,
        });
      } else {
        res = await getOwnCarsInNegotiationBuyNowApiHandler({
          params,
        });
      }
    }

    setPaginationData((paginationData) => {
      return {
        ...paginationData,
        data: [...(res?.data?.Vehicle?.data || res?.data?.Vehicle || [])],
        isFetching: false,
        current_page: res?.data?.Vehicle?.current_page || paginationData?.current_page,
        last_page: res?.data?.Vehicle?.last_page || paginationData?.last_page,
      };
    });
  };

  // useEffect start...
  React.useEffect(() => {
    const debouncedFetchData = debounce(async () => {
      await fetchPaginationDataHandler({
        params,
      });

      // dispatch(
      //   setLiveAuctionMultipleFields({
      //     liveAuctionData: {
      //       ...liveAuction?.liveAuctionData,
      //       data: res?.data?.Vehicle?.data || []
      //     }
      //   })
      // );
    }, 1000);

    debouncedFetchData();

    return () => {
      debouncedFetchData.cancel(); // Cleanup function to cancel pending calls
    };
  }, [subRoute, params]);

  React.useEffect(() => {
    (async () => {
      await fetchPaginationDataHandler({
        params,
      });
    })();
  }, [subRoute, value, params]);

  React.useEffect(() => {
    if (onMyCarsOrOtherCars) {
      onMyCarsOrOtherCars(value);
    }
  }, [value]);
  // useEffect end...

  return (
    <Box
      display={'flex'}
      width={'100%'}
      sx={{
        borderRadius: '24px',
        height: {
          lg: `calc(100vh - 94px)`,
          md: `calc(100vh - 94px)`,
          xs: paginationData?.data?.length === 0 ? 'calc(100vh - 118px)' : 'auto',
        },
        position: 'relative',
      }}
    >
      <Box
        sx={{
          flex: '1',
          display: 'flex',
          flexDirection: 'column',
          background: theme.palette.background.paper,
          borderRadius: '24px',
          width: '100%',
        }}
      >
        <Paper elevation={0} sx={{ borderRadius: '24px' }}>
          <Box sx={{ padding: { xs: 2, sm: 3, md: 3 } }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'space-between',
                alignItems: { xs: 'flex-start', sm: 'center' },
                gap: { xs: 2, sm: 1 },
              }}
            >
              <Typography
                variant={'h1'}
                sx={{
                  fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
                  fontWeight: 600,
                  color: theme.palette.primary.main,
                }}
              >
                {/* {t('carsInNegotiation')} */}
                {t(
                  liveAuctionOrBuyNow === auctionTypes.liveAuction
                    ? 'Cars in negotiation'
                    : 'Cars in negotiation buy now'
                )}
              </Typography>

              <Box
                sx={{
                  display: 'flex',
                  gap: 1,
                  alignItems: 'center',
                  width: { xs: '100%', sm: 'auto' },
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: { xs: 'center', sm: 'flex-start' },
                    width: { xs: '100%', sm: 'auto' },
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      border: '1px solid',
                      borderColor: 'border.main',
                      p: 0.5,
                      borderRadius: 2,
                      overflow: 'hidden',
                      width: { xs: '100%', sm: 'auto' },
                    }}
                  >
                    <MyCarsOrOtherCarsButton value={value} setValue={setValue} />
                  </Box>
                </Box>
              </Box>
            </Box>

            {/* Filters Section */}
            {/* <Box sx={styles.filterInputsContainer}>
            <Box sx={styles.filterInputBox}>
              <InputLabel>{t("selectMake")}</InputLabel>
              <Select
                value={selectedMakes}
                onChange={(e) => setSelectedMakes(selectedMakes => {
                  return e?.target?.value?.filter(item => item);
                })}
                displayEmpty
                fullWidth
                multiple={true}
                endAdornment={
                  <Box
                    sx={{
                      paddingRight: "1rem"
                    }}
                  >
                    {selectedMakes
                      ?.filter(item => item)
                      ?.length > 0 ? <Button
                      sx={{
                        padding: "0",
                        minWidth: "0",
                      }}
                      onClick={(e) => {
                        setSelectedMakes([""]);
                      }}
                    >
                      <CancelTwoTone
                        sx={{
                          color: theme.palette.text.primary
                        }}
                      />
                    </Button> : null}
                  </Box>
                }
              >
                <MenuItem value="" disabled={true}>{t("select")}</MenuItem>
                {allMakes?.map?.(make => {
                  return (
                    <MenuItem value={make}>
                      {make?.label}
                    </MenuItem>
                  )
                })}
              </Select>
            </Box>

            <Box sx={styles.filterInputBox}>
              <InputLabel>{t("selectModel")}</InputLabel>
              <Select
                value={selectedModels}
                onChange={(e) => {
                  setSelectedModels(e.target.value?.filter?.(item => item))
                }}
                displayEmpty
                fullWidth
                multiple={true}
                endAdornment={
                  <Box
                    sx={{
                      paddingRight: "1rem"
                    }}
                  >
                    {selectedModels
                      ?.filter(item => item)
                      ?.length > 0 ? <Button
                      sx={{
                        padding: "0",
                        minWidth: "0",
                      }}
                      onClick={(e) => {
                        setSelectedModels([""]);
                      }}
                    >
                      <CancelTwoTone
                        sx={{
                          color: theme.palette.text.primary
                        }}
                      />
                    </Button> : null}
                  </Box>
                }
              >
                <MenuItem value="" disabled={true}>{t("select")}</MenuItem>

                {allModels?.map(item => {
                  return (
                    <MenuItem value={item}>
                      {item?.label}
                    </MenuItem>
                  )
                })}
              </Select>
            </Box>

            <Box 
              sx={{
                ...styles.filterInputBox,
                minWidth: "15rem"
              }}
            >
              <InputLabel>{t("selectYear")}</InputLabel>
              <Box sx={styles.yearSelectContainer}>
                <Select
                  value={selectedYearFrom}
                  onChange={(e) => setSelectedYearFrom(e.target.value)}
                  displayEmpty
                  fullWidth
                  endAdornment={
                    <Box
                      sx={{
                        paddingRight: "1rem"
                      }}
                    >
                      {selectedYearFrom ? <Button
                        sx={{
                          padding: "0",
                          minWidth: "0",
                        }}
                        onClick={(e) => {
                          setSelectedYearFrom("");
                        }}
                      >
                        <CancelTwoTone
                          sx={{
                            color: theme.palette.text.primary
                          }}
                        />
                      </Button> : null}
                    </Box>
                  }
                >
                  <MenuItem value="">{t("from")}</MenuItem>
                  {years?.map(year => {
                    return (
                      <MenuItem value={year}>
                        {year}
                      </MenuItem>
                    )
                  })}
                </Select>

                <Select
                  value={selectedYearTo}
                  onChange={(e) => setSelectedYearTo(e.target.value)}
                  displayEmpty
                  fullWidth
                  endAdornment={
                    <Box
                      sx={{
                        paddingRight: "1rem"
                      }}
                    >
                      {selectedYearTo ? <Button
                        sx={{
                          padding: "0",
                          minWidth: "0",
                        }}
                        onClick={(e) => {
                          setSelectedYearTo("");
                        }}
                      >
                        <CancelTwoTone
                          sx={{
                            color: theme.palette.text.primary
                          }}
                        />
                      </Button> : null}
                    </Box>
                  }
                >
                  <MenuItem value="">{t("To")}</MenuItem>

                  {years?.map(year => {
                    return (
                      <MenuItem value={year}>
                        {year}
                      </MenuItem>
                    )
                  })}
                </Select>
              </Box>
            </Box>

            <Box 
              sx={{
                ...styles.filterInputBox,
                minWidth: "15rem"
              }}
            >
              <InputLabel>{t("odometer")}</InputLabel>
              <Box sx={styles.odometerInputContainer}>
                <TextField
                  type="number"
                  value={odometerFrom}
                  onChange={(e) => setOdometerFrom(e.target.value)}
                  placeholder={t("fromKm")}
                  fullWidth
                />
                <TextField
                  type="number"
                  value={odometerTo}
                  onChange={(e) => setOdometerTo(e.target.value)}
                  placeholder={t("toKm")}
                  fullWidth
                />
              </Box>
            </Box>
          </Box> */}

            {/* Selected Brands */}
            {selectedMakes?.filter?.((item) => item)?.length > 0 ? (
              <Box sx={styles.selectedBrandsContainer}>
                {selectedMakes.map((make) => (
                  <Chip
                    key={make?.value}
                    label={make?.label}
                    variant="outlined"
                    onDelete={() => {
                      setSelectedMakes((selectedMakes) => {
                        return selectedMakes?.filter?.((currMake) => make?.value !== currMake?.value);
                      });
                    }}
                    sx={styles.selectedBrandChip}
                    deleteIcon={<Cancel />}
                  />
                ))}
              </Box>
            ) : null}
          </Box>
        </Paper>

        <Box
          sx={{
            height: 'calc(100% - 96px)',
            overflowY: 'auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            scrollbarWidth: 'none !important' /* Firefox */,
            '-ms-overflow-style': 'none' /* IE and Edge */,
            padding: { xs: 2, sm: 3, md: 3 },
            marginBottom: { xs: 3, sm: 3, md: 3 },
          }}
        >
          {paginationData?.isFetching ? (
            // Skeleton UI
            <Box sx={{ height: '100%', width: '100%' }}>
              <Grid container spacing={{ xs: 2, sm: 2, md: 3 }}>
                {[...Array(8)].map((_, index) => (
                  <Grid key={index} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <Box
                      sx={{
                        backgroundColor: theme.palette.background.paper,
                        borderRadius: 2,
                        padding: 2,
                        border: `1px solid ${theme.palette.divider}`,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      }}
                    >
                      {/* Car image skeleton */}
                      <Box sx={{ position: 'relative', marginBottom: 2 }}>
                        <Skeleton variant="rectangular" width="100%" height={200} sx={{ borderRadius: 1.5 }} />

                        {/* Timer skeleton in top right */}
                        <Box
                          sx={{
                            position: 'absolute',
                            bottom: 8,
                            right: 8,
                          }}
                        >
                          <Skeleton variant="rectangular" width={130} height={40} sx={{ borderRadius: 1 }} />
                        </Box>
                      </Box>

                      {/* Car details skeleton */}
                      <Box sx={{ marginBottom: 2 }}>
                        {/* Car title */}
                        <Skeleton variant="text" width="80%" height={24} sx={{ marginBottom: 1 }} />

                        {/* VIN */}
                        <Skeleton variant="text" width="60%" height={16} sx={{ marginBottom: 1 }} />

                        {/* Car specs grid */}
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, marginBottom: 2 }}>
                          {[...Array(4)].map((_, specIndex) => (
                            <Box key={specIndex}>
                              <Skeleton variant="text" width="50%" height={14} sx={{ marginBottom: 0.5 }} />
                              <Skeleton variant="text" width="70%" height={16} />
                            </Box>
                          ))}
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          ) : paginationData?.data?.length === 0 ? (
            <Typography
              sx={{
                fontWeight: '500',
                fontSize: { xs: '1.25rem', sm: '1.5rem', md: '2rem' },
                textAlign: 'center',
                marginTop: { xs: '-100px', md: '-200px' },
              }}
            >
              No data found
            </Typography>
          ) : (
            <Box
              sx={{
                height: '100%',
                width: '100%',
                padding: { xs: 0, sm: 0 },
              }}
            >
              <CarsList
                showRemainingTime={false}
                // cars={cars}
                cars={paginationData?.data?.map?.((vehicle) => {
                  return {
                    ...vehicle,
                    showNavigateToDetailsPage: true,
                    navigateToDetailsBtnLabel: "Start negotiation",
                    dontShowCurrentOffer: true,
                    dontShowBuyNow: true,
                    dontShowCountDown: true,
                    dontShowPlaceABid: true,
                    dontShowMakeOffer: true,
                    dontShowOrSeparator: true,
                    vin: vehicle?.VIN,
                    year: vehicle?.Year,
                    make: vehicle?.Make,
                    model: vehicle?.Model,
                    odometer: vehicle?.Mileage,
                    image: vehicle?.Exterior_Image
                      ? `${baseImageUrl}/${vehicle?.Vehicle_Id}/${vehicle?.Exterior_Image}`
                      : ``,
                  };
                })}
                Component={CarContainer1}
                ChildComponent={liveAuctionOrBuyNow === auctionTypes.liveAuction ? CarListingCard : VehicleListingCard}
                onClick={(car) => {
                  console.log(car, `CarsList`);
                  if (onCarClick) {
                    onCarClick(car);
                  }
                }}
              />
            </Box>
          )}
        </Box>

        {paginationData?.last_page > 1 ? (
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              position: 'absolute',
              bottom: '0px',
              padding: { xs: 1, sm: 0 },
            }}
          >
            <Pagination
              count={paginationData?.last_page}
              page={paginationData?.current_page}
              onChange={handlePageChange}
              size={'small'}
              siblingCount={isMobile ? 0 : isTablet ? 1 : 1}
              boundaryCount={isMobile ? 1 : 2}
            />
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

export default CarsInNegotationList;
